import React from 'react';
import { InfoImage } from '../Product/ProductInfoImages/styled';
import { calculatePaddingTop } from '../CategoryL2Page/utils';
import { ImageGridContainer } from './styled';
import Image from 'next/image';

const ImagesGrid = () => {
  const data = [
    [
      {
        url: 'https://images.myloapp.in/NestJsUploads/1720525799718-3.webp',
        aspectRatio: '112:200',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1720502450074-c1i2.webp',
        aspectRatio: '112:100',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1720502450073-c1i3.webp',
        aspectRatio: '112:100',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1720502450070-c1i4.webp',
        aspectRatio: '112:100',
      },
    ],
    [
      {
        url: 'https://images.myloapp.in/NestJsUploads/1720502532925-c2i1.webp',
        aspectRatio: '112:100',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1720502532925-c2i2.webp',
        aspectRatio: '112:100',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1720502532924-c2i3.webp',
        aspectRatio: '112:100',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1720525799718-2.webp',
        aspectRatio: '112:200',
      },
    ],
    [
      {
        url: 'https://images.myloapp.in/NestJsUploads/1720502585129-c3i1.webp',
        aspectRatio: '112:100',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1720525799717-1.webp',
        aspectRatio: '112:200',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1720502585129-c3i3.webp',
        aspectRatio: '112:100',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1720502585128-c3i4.webp',
        aspectRatio: '112:100',
      },
    ],
  ];
  return (
    <ImageGridContainer>
      <h3>LOVED BY 10 Mn+ MOMS ❤️</h3>
      <div className="grid">
        {data?.map((item, index) => {
          return (
            <div key={'imageCol' + index}>
              {item.map((img, index) => {
                return (
                  <InfoImage
                    key={'diaperImage' + index}
                    paddingTop={calculatePaddingTop(img.aspectRatio)}
                  >
                    <Image
                      src={img.url}
                      alt=""
                      loading="lazy"
                      quality={90}
                      fill
                      sizes="50vw"
                    />
                  </InfoImage>
                );
              })}
            </div>
          );
        })}
      </div>
    </ImageGridContainer>
  );
};

export default ImagesGrid;
